import { useEffect } from 'react'

import { useConnect } from 'redux-bundler-hook'

import { GlobalStyles } from '@mui/material'
import { styled } from '@mui/material/styles'

import createLogger from '~/src/Lib/Logging'
import { lazyWithRetries, useIsLoaded } from '~/src/Lib/Utils'
import getClassPrefixer from '~/src/UI/classPrefixer'
import Head from '~/src/UI/Shared/Head'

import config from './config'
import styles, { globals } from './styles'

const SpinnerRoute = lazyWithRetries(() => import('~/src/Routes/SpinnerRoute'))
const displayName = 'App/Public'
const logger = createLogger(displayName)
const classes = getClassPrefixer(displayName)
const Root = styled('section')(({ theme }) => styles(theme, classes))

const PublicWrapper = () => {
  const { appIsReady, landingPage, locale, routeInfo, doUpdateUrl } = useConnect(
    'selectAppIsReady',
    'selectLandingPage',
    'selectLocale',
    'selectRouteInfo',
    'doUpdateUrl',
  )
  const loaded = useIsLoaded(!appIsReady)
  const { url, value: route } = routeInfo
  const { additionalProps, title, component, publicAccess = false } = route
  const Route = publicAccess ? (component ?? route) : SpinnerRoute

  useEffect(() => {
    if (!loaded) {
      return
    }
    if (url === '/') {
      doUpdateUrl(landingPage)
    }
  }, [doUpdateUrl, landingPage, loaded, url])

  return (
    <>
      <Head>
        <html className={config.APP.toLowerCase()} lang={locale} />
        {title ? <title>{title}</title> : null}
        <style>{'html: { overflow: hidden; }'}</style>
      </Head>
      <GlobalStyles styles={globals} />
      <Root data-testid="aroya-public" id="wrapper" className={classes.fullscreen}>
        <main id="content" className={classes.content}>
          <Route {...additionalProps} />
        </main>
      </Root>
    </>
  )
}
PublicWrapper.displayName = displayName

export default PublicWrapper
